module.exports = __webpack_public_path__ + "img/purchase2.2b4a6934.png";